import { render, staticRenderFns } from "./DetailCustomerProfile.vue?vue&type=template&id=353f9644&scoped=true"
import script from "./DetailCustomerProfile.vue?vue&type=script&lang=js"
export * from "./DetailCustomerProfile.vue?vue&type=script&lang=js"
import style0 from "./DetailCustomerProfile.vue?vue&type=style&index=0&id=353f9644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f9644",
  null
  
)

export default component.exports